import { useState, useEffect } from "react";
import DatePicker from "@general/datePicker";
import moment from "moment-jalaali";
import { Row, Col, Form, TimePicker, Button, List, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import useReservedHours from "@general/useReservedHours";

moment.loadPersian({ usePersianDigits: false });
const MtSecondStep = ({
  onUserChangeSelectedDates,
  sessions,
  selectedMeetingRoom,
}) => {
  const [form] = Form.useForm();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTimesList, setSelectedTimesList] = useState([]);
  const [userRequestedDateTimes, setUserRequestedDateTimes] = useState([]);
  const reservedHours = useReservedHours(selectedMeetingRoom, selectedDate);

  function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }
  const disabledDateTime = () => {
    const disablehours = range(0, 8).concat(range(21, 24));
    reservedHours &&
      reservedHours.map((time) => {
        const start = parseInt(time?.startAt);
        const end = parseInt(time?.endAt);
        for (let i = start; i <= end; i++) {
          disablehours.push(i);
        }
      });

    return {
      disabledHours: () => disablehours,
    };
  };
  const addSelectedTime = (inputs) => {
    const gegorianSelectedDate = moment(
      selectedDate.dateString,
      "jYYYY/jMM/jDD"
    ).format("YYYY/M/D");
    const startAt = moment(inputs.startAt).format("LT");
    const endAt = moment(inputs.startAt).add(1, "hours").format("LT");
    const uId = Date.now().toString(36);
    const sameTime = selectedTimesList.filter(
      (time) =>
        time.date === selectedDate?.dateString && time.startAt === startAt
    );

    if (sameTime.length)
      return Modal.error({
        title: "مشکلی پیش آمده!",
        content: "انتخاب ساعت تکراری توسط کاربر!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    setSelectedTimesList([
      ...selectedTimesList,
      {
        date: selectedDate?.dateString,
        startAt,
        endAt,
        id: uId,
      },
    ]);
    setUserRequestedDateTimes([
      ...userRequestedDateTimes,
      {
        startAt: moment(gegorianSelectedDate + " " + startAt)
          .toDate()
          .toISOString(),
        endAt: moment(gegorianSelectedDate + " " + endAt)
          .toDate()
          .toISOString(),
        id: uId,
      },
    ]);
  };

  const deleteSelectedTime = (toBeDeletedItem) => {
    const newSelectedTimesList = selectedTimesList.filter(
      (time) => time.id !== toBeDeletedItem.id
    );
    setSelectedTimesList(newSelectedTimesList);

    const newUserRequesetDateTimes = userRequestedDateTimes.filter(
      (time) => time.id !== toBeDeletedItem.id
    );
    setUserRequestedDateTimes(newUserRequesetDateTimes);
  };

  useEffect(() => {
    const dateTimes = [];
    userRequestedDateTimes.map((dateTime) => {
      const { id, ...rest } = dateTime;
      dateTimes.push(rest);
    });
    onUserChangeSelectedDates(dateTimes);
  }, [userRequestedDateTimes]);

  return (
    <>
      <Row style={{ marginBottom: 30 }}>
        <p>
          توجه داشته باشید که مدت زمان هر جلسه 60 دقیقه است و شما باید تعداد{" "}
          {sessions} جلسه از زمان های در دسترس را انتخاب کنید. تمامی زمان های قابل انتخاب در تاریخ انتخاب شده قابل رزرو هستند.
        </p>
      </Row>
      <Col xs={12}>
        <Form layout="vertical" onFinish={addSelectedTime} form={form}>
          <Row>
            <Col xs={12}>
              <Form.Item name="date" label="انتخاب روز">
                <DatePicker
                  placeholder={"انتخاب تاریخ"}
                  disabledDate={(current) => current < moment().startOf("day")}
                  onChange={(date, dateString) =>
                    setSelectedDate({ date, dateString })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item name="startAt" label="انتخاب ساعت شروع">
                <TimePicker
                  placeholder={"ساعت شروع"}
                  format={"HH:mm"}
                  showNow={false}
                  minuteStep={30}
                  disabledTime={disabledDateTime}
                  hideDisabledOptions={true}
                  disabled={
                    selectedDate && selectedDate !== "Invalid date"
                      ? false
                      : true
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Button type="primary" htmlType="submit">
              افزودن
            </Button>
          </Row>
        </Form>
      </Col>
      <Col xs={12}>
        <div style={{ overflowY: "auto", maxHeight: "350px" }}>
          <List
            dataSource={selectedTimesList}
            bordered
            header={<h3>زمان های انتخاب شده:</h3>}
            renderItem={(time) => (
              <List.Item key={time.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`${time.date} از ${time.startAt} تا ${time.endAt}`}</span>
                  <DeleteOutlined
                    style={{ fontSize: 16 }}
                    onClick={() => deleteSelectedTime(time)}
                  />
                </div>
              </List.Item>
            )}
          />
        </div>
      </Col>
    </>
  );
};

export default MtSecondStep;
